export const versions = {
  version: "1.0.183",
  revision: "61e1c68f0",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5310-g61e1c68f0-dirty",
    hash: "g61e1c68f0",
    distance: 5310,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5310-g61e1c68f0-dirty",
    semverString: "1.0.183+5310.g61e1c68f0.dirty"
  }
};
